const KIND_TAG = {
    bundle: 'BUNDLE',
    dev_network: 'DEV WALLETS',
    wallet_farm: 'WALLET FARM',
    funder: 'SHARED FUNDER',
    funding_tree: 'SHARED FUNDER',
    direct_funding: 'INSIDER FUNDED',
    distribution: 'TOKEN SPLIT',
    cex_batch: 'CEX BATCH',
    gas_sponsored: 'SPONSORED',
};
export const RISK_PALETTE = {
    high: ['#ff4d5e', '#ff7a45', '#ff6b9a', '#e8455a', '#ff9466', '#f0507e'],
    medium: ['#f5b13d', '#ffd166', '#f59e0b', '#ffc27a', '#e9b949'],
    low: ['#50a1fa', '#8b9dff', '#7db8ff', '#3d8bff'],
};
const pct = (p) => (p >= 10 ? `${p.toFixed(0)}%` : p >= 0.1 ? `${p.toFixed(1)}%` : p > 0 ? '<0.1%' : '0%');
export function tokenMaturity(t, nowSec = Date.now() / 1000) {
    const mc = t.marketCapUsd ?? t.fdvUsd ?? 0;
    const vol = t.volume24hUsd ?? 0;
    const ageDays = t.createdAt ? Math.max(0, (nowSec - t.createdAt) / 86_400) : undefined;
    const old = (days) => (ageDays === undefined ? undefined : ageDays >= days);
    if (mc >= 100e6 && vol >= 500e3 && (old(30) ?? mc >= 250e6))
        return { level: 'established', ageDays };
    if (mc >= 10e6 && vol >= 100e3 && (old(7) ?? true))
        return { level: 'growing', ageDays };
    return { level: 'new', ageDays };
}
/** Maturity of the token on screen; one token is shown at a time. */
let currentMaturity = 'new';
export const setRiskMaturity = (m) => void (currentMaturity = m);
export function groupRiskLevel(g, maturity = currentMaturity) {
    const held = g.stats.holdingPercent;
    // Gone already: nothing left to dump on a new buyer.
    if (g.status === 'exited' && held < 0.1)
        return 'low';
    if (g.kind === 'cex_batch')
        return held >= 5 ? 'medium' : 'low';
    // Selling right now is a live risk at any size of token.
    const selling = g.status === 'distributing' && held >= 0.5;
    if (maturity === 'established') {
        if (selling && held >= 1)
            return 'high';
        // Big linked holders of an established token are mostly team, treasury
        // or vesting wallets: worth watching, not a trap by themselves.
        return held >= 1 || selling ? 'medium' : 'low';
    }
    if (maturity === 'growing' && !selling && held < 0.5 && (g.kind === 'bundle' || g.kind === 'dev_network' || g.kind === 'wallet_farm'))
        return 'medium';
    if (g.kind === 'bundle' || g.kind === 'dev_network' || g.kind === 'wallet_farm')
        return 'high';
    if (held >= 5)
        return 'high';
    if (g.status === 'distributing' && held >= 0.5)
        return 'high';
    return 'medium';
}
export function groupRisk(g, maturity = currentMaturity) {
    const level = groupRiskLevel(g, maturity);
    const pal = RISK_PALETTE[level];
    const color = pal[((g.color % pal.length) + pal.length) % pal.length];
    const kind = KIND_TAG[g.kind] ?? 'LINKED';
    const pos = groupPosition(g);
    const state = g.status === 'distributing' ? ' · SELLING' : pos.state === 'sold' ? ' · SOLD OUT' : pos.state === 'moved' || pos.state === 'mixed' ? ' · MOVED OUT' : g.status === 'exited' ? ' · EXITED' : '';
    return { level, kind, color, tag: `${kind} · ${pct(g.stats.holdingPercent)}${state}` };
}
export function groupPosition(g) {
    const s = g.stats;
    const held = s.holdingPercent;
    const peak = Math.max(s.peakPercent, held);
    const soldShare = s.tokensBought > 0 ? Math.min(1, s.tokensSold / s.tokensBought) : 0;
    const gone = held < 0.01 || (peak > 0 && held <= peak * 0.02);
    const state = gone
        ? soldShare >= 0.8
            ? 'sold'
            : soldShare <= 0.2
                ? 'moved'
                : 'mixed'
        : peak > 0 && held < peak * 0.5
            ? 'reduced'
            : 'holding';
    return { state, held, peak, soldShare, netSol: s.netSol };
}
/** Colour of a group wherever it is drawn. */
export const groupTint = (g, maturity = currentMaturity) => groupRisk(g, maturity).color;
//# sourceMappingURL=risk.js.map